import './BookingSuccessModal.css'
import { formatPhoneNumber } from '../utils/format.util'
import React from 'react'

interface BookingSuccessModalProps {
  isOpen: boolean
  onClose: () => void
  reload: () => void
  phoneNumber: string
  orderNumber: string
  email: string
}

export default function BookingSuccessModal({
  isOpen,
  onClose,
  reload,
  phoneNumber,
  orderNumber,
  email,
}: BookingSuccessModalProps) {
  if (!isOpen) return null

  return (
    <div className='BookingSuccessModal-overlay' onClick={onClose}>
      <div className='BookingSuccessModal-main' onClick={e => e.stopPropagation()}>
        <div className='BookingSuccessModal-content'>
          <div className='BookingSuccessModal-icon'>✓</div>
          <h2 className='BookingSuccessModal-title'>Booking Successful!</h2>
          <h3 className='BookingSuccessModal-orderNumber'>Order Number: {orderNumber}</h3>
          <p className='BookingSuccessModal-message'>
            Your laundry booking has been submitted successfully. We'll contact you shortly at{' '}
            <strong>
              {formatPhoneNumber(phoneNumber)} / {email}
            </strong>{' '}
            soon to confirm the details.
            <br />
            <br />
            <small style={{ color: 'red' }}>Put in the wrong number? Please resubmit it and we'll replace it.</small>
          </p>
          <button
            className='BookingSuccessModal-button'
            onClick={() => {
              onClose()
              reload()
            }}>
            Close
          </button>
        </div>
      </div>
    </div>
  )
}
